import {Routes} from '@angular/router';
import {ReportGeneralComponent} from './report-general/report-general.component';
import {ReportOrgComponent} from './report-org/report-org.component';
import {LoginComponent} from './login/login.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {AuthGuard} from '../../core/interceptors/auth.guard';
import {indexResolver} from './index-entity/index.resolver';
import {IndexEntityComponent} from './index-entity/index-entity.component';
import {CriterionComponent} from './criterion/criterion.component';
import {criterionResolver} from './criterion/criterion.resolver';
import {IndicatorsComponent} from './indicators/indicators.component';
import {indicatorsResolver} from './indicators/indicators.resolver';
import {LandmarksComponent} from './landmarks/landmarks.component';
import {landmarksResolver} from './landmarks/landmarks.resolver';
import {GroupComponent} from './group/group.component';
import {groupResolver} from './group/group.resolver';
import {OrganizationComponent} from './organization/organization.component';
import {organizationResolver} from './organization/organization.resolver';
import {FacilityComponent} from './facility/facility.component';
import {facilityResolver} from './facility/facility.resolver';
import {DepartmentComponent} from './department/department.component';
import {departmentResolver} from './department/department.resolver';
import {IndexIasComponent} from './index-ias/index-ias.component';
import {indexIasResolver} from './index-ias/index-ias.resolver';
import {UsersComponent} from './users/users.component';
import {usersResolver} from './users/users.resolver';
import {GradeComponent} from './grade/grade.component';
import {gradeResolver} from './grade/grade.resolver';
import {CreateGradeComponent} from './create-grade/create-grade.component';
import {gradeEditResolver} from './grade/grade-edit.resolver';
import {viewGuard} from '../../core/interceptors/view.guard';
import {AccessDeniedComponent} from './access-denied/access-denied.component';
import {ReportPropertyModComponent} from './report-property-mod/report-property-mod.component';
import {canCreateResolver} from "./can-create.resolver";
import {ReportOccupiedPlacesComponent} from "./report-occupied-places/report-occupied-places.component";
import { RestorePasswordComponent } from "./restore-password/restore-password.component";
import { IndexListValueComponent } from './index-list-value/index-list-value.component';
import { indexListValueResolver } from './index-list-value/index-list-value.resolver';


export const routes: Routes = [
  {path: 'login', title: 'Авторизация', component: LoginComponent},
  {path: 'restore-password', title: 'Авторизация', loadComponent: () => import('./restore-password/restore-password.component').then(m=>m.RestorePasswordComponent)},
  {path: 'logout', title: 'Авторизация', component: LoginComponent},
  {
    path: 'index-entity',
    title: 'Индексы',
    component: IndexEntityComponent,
    resolve: {
      data: indexResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('indexentity')],
  },
  {
    path: 'criterion',
    title: 'Критерии',
    component: CriterionComponent,
    resolve: {
      data: criterionResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('criterion')],
  },
  {
    path: 'indicators',
    title: 'Показатели',
    component: IndicatorsComponent,
    resolve: {
      data: indicatorsResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('indicator')],
  },
  {
    path: 'landmarks',
    title: 'Целевые ориентиры',
    component: LandmarksComponent,
    resolve: {
      data: landmarksResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('landmark')],
  },
  {
    path: 'group',
    title: 'Группы учреждений',
    component: GroupComponent,
    resolve: {
      data: groupResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('org_group')],
  },
  {
    path: 'organization',
    title: 'Учреждения МКС',
    component: OrganizationComponent,
    resolve: {
      data: organizationResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('ref_organization')],
  },
  {
    path: 'facility',
    title: 'Объекты учреждений МКС',
    component: FacilityComponent,
    resolve: {
      data: facilityResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('facility')],
  },
  {
    path: 'department',
    title: 'Структурные подразделения Москомспорта',
    component: DepartmentComponent,
    resolve: {
      data: departmentResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('department')],
  },
  {
    path: 'index-ias',
    title: 'Значения индексов ИАС Спорт',
    component: IndexIasComponent,
    resolve: {
      data: indexIasResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('indexiasvalue')],
  },
  {
      path: 'index-list-value',
      title: 'Значения индексов (выбор из списка)',
      component: IndexListValueComponent,
      resolve: {
        data: indexListValueResolver,
        canCreate: canCreateResolver
      },
      canActivate: [AuthGuard, viewGuard('indexlistvalue')],
  },
  {
    path: 'users',
    title: 'Администрирование',
    component: UsersComponent,
    resolve: {
        data: usersResolver,
        canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('useraccount')],
  },
  {
    path: 'grade/create',
    title: 'Создание оценки',
    component: CreateGradeComponent,
    canActivate: [AuthGuard,viewGuard('create')],
  },
  {
    path: 'grade/:id',
    title: 'Редактирование оценки',
    component: CreateGradeComponent,
    resolve: {
      data: gradeEditResolver,
      canCreate: canCreateResolver
    },
    canActivate: [AuthGuard, viewGuard('grade')],
  },
  {
    path: 'grade',
    title: 'Реестр оценок',
    component: GradeComponent,
    resolve: {
      data: gradeResolver,
      canCreate: canCreateResolver,
    },
    canActivate: [AuthGuard, viewGuard('grade')],
  },
  {
    path: 'access-denied',
    title: 'Доступ закрыт',
    component: AccessDeniedComponent,
  },

  {path: 'report-general', title: 'Общий отчёт', component: ReportGeneralComponent, canActivate: [AuthGuard]},
  {path: 'report-property', title: 'Имущественный комплекс', component: ReportPropertyModComponent, canActivate: [AuthGuard]},
  {path: 'report-org', title: 'Отчёт по учреждению', component: ReportOrgComponent, canActivate: [AuthGuard]},
  {path: 'report-occupied-places', title: 'Динамика занятых мест', component: ReportOccupiedPlacesComponent, canActivate: [AuthGuard]},



  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: '404', component: PageNotFoundComponent, title: 'Страница не найдена'},
  {path: '**', component: PageNotFoundComponent, title: 'Страница не найдена'}
];
